import React from 'react';

import {
  GridRow,
  GridRowProps,
  DataGridProps as MuiDataGridProps,
} from '@mui/x-data-grid';

import Link from '../Link';

import { StyledDataGrid } from './index.styles';

interface LinkRowProps extends GridRowProps {
  getHref: (row: any) => string;
}

const LinkRow = ({ getHref, target, ...props }: LinkRowProps) => (
  <Link
    className="LinkRow-row"
    href={getHref(props.row)}
    target={target}
    underline="none"
    color="inherit"
  >
    <GridRow
      className="LinkRow-MuiDataGrid-row"
      {...props}
    />
  </Link>
);

export interface DataGridProps extends MuiDataGridProps {
  selectedRowId?: string,
  getRowHref?: (row: any) => string
  rowHrefTarget?: string
}

const DataGrid = ({ selectedRowId, getRowHref, rowHrefTarget, ...rest }: DataGridProps) => (
  <StyledDataGrid
    {...getRowHref ? {
      slots: {
        row: LinkRow,
      },
      slotProps: {
        row: { getHref: getRowHref, target: rowHrefTarget },
      },
    } : {}}
    disableRowSelectionOnClick
    checkboxSelection={false}
    rowHeight={40}
    autoHeight
    getRowClassName={(params) => (selectedRowId && params.row.id === selectedRowId ? 'MuiDataGrid-row--selected' : '')}
    {...rest}
  />
);

export default DataGrid;
